import { GET_HOT_OFFER, GET_HOT_OFFERS, GET_OFFER, GET_OFFERS } from './types';

export const getOffers = (offers) => ({
  type: GET_OFFERS,
  payload: offers,
});

export const getOffer = (offer) => ({
  type: GET_OFFER,
  payload: offer,
});

export const getHotOffers = () => ({
  type: GET_HOT_OFFERS,
});

export const getHotOffer = (id) => ({
  type: GET_HOT_OFFER,
  payload: id,
});
